class MenstrualHistory {
    public DaysInCycle: number;
    public LastMenstrualPeriod: Date;
    public EstimatedDateOfConfinement: Date;
    public PositivePregnancyTestOn: Date;
    public EmbryoTransferDate: Date;
    public IgnoreDaysInCycle: boolean;

    constructor(fields?: Partial<MenstrualHistory>) {
        Object.assign(this, fields);
        this.DaysInCycle = fields?.DaysInCycle ?? 28;
    }
}

export { MenstrualHistory };
